import { appConfig } from "config/app-config";
import { create } from "./store";
import { AppStatusTypes, AgentStatusTypes } from "types/AppStatusTypes";

type AppStatusStoreState = {
  appStatus: AppStatusTypes;
  agentStatus: AgentStatusTypes;
  windowW: number;
  language: string;
};

type AppStatusStoreActions = {
  setAppStatus: (status: AppStatusTypes) => void;
  setAgentStatus: (status: AgentStatusTypes) => void;
  setWindowW: (value: number) => void;
  clearAppStatus: () => void;
};

const initialState: AppStatusStoreState = {
  appStatus: "idle",
  agentStatus: "idle",
  windowW: 0,
  language: appConfig.language,
};

const appStatusStore = create<AppStatusStoreState & AppStatusStoreActions>()(
  (set) => ({
    ...initialState,
    setAppStatus: (status) => {
      set({ appStatus: status });
    },
    setAgentStatus: (status) => {
      set({ agentStatus: status });
    },
    setWindowW: (value) => {
      set({ windowW: value });
    },
    clearAppStatus: async () => {
      set({ appStatus: "idle" });
    },
  }),
);

export default appStatusStore;
